module.exports = __webpack_public_path__ + "static/media/02_web_website-yeutech-doc.81dc6a23.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/02_web_website-yeutech-doc.png
// module id = 68
// module chunks = 0